import React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import useEventListner from '../../useEventListner';
import VendexAction from '../../../models/VendexAction';
import { VendexTimerMeta } from '../../../models/VendexElement';

type Props = {
  id: string;
  actions?: VendexAction[];
  data: VendexTimerMeta;
};

const VendexTimer: React.FC<Props> = ({ id, data, actions }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [counter, setCounter] = React.useState(data.duration);
  const [counterText, setCounterText] = React.useState('');
  useEventListner(ref, actions);

  React.useEffect(() => {
    let timer: string | number | NodeJS.Timeout | undefined;
    if (data.showCountdown) {
      setCounterText(fancyTimeFormat(counter));
      timer = setInterval(() => setCounter(counter > 0 ? counter - 1 : counter), 1000);
      return () => clearInterval(timer);
    }
    if (counter === 0) {
      clearInterval(timer);
    }
  }, [counter]);

  const { start } = useIdleTimer({
    timeout: data.duration * 1000,
    onIdle: () => handleIdle(),
    startManually: true,
  });

  React.useEffect(() => {
    if (data.type === 'STRICT') {
      setTimeout(handleIdle, data.duration * 1000);
    }
    if (data.type === 'IDLE') {
      start();
    }
  }, []);

  const handleIdle = () => {
    ref.current?.dispatchEvent(new CustomEvent('timeout', { bubbles: true }));
  };

  const fancyTimeFormat = (s: number) => {
    return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
  };
  return (
    <div ref={ref} data-vendex>
      {data.showCountdown && <p id={id}>{counterText}</p>}
    </div>
  );
};

export default VendexTimer;
